module.exports = __webpack_public_path__ + "img/craftBannerRoofer.0fb054a.webp";